module.exports = __webpack_public_path__ + "img/button_backtointro-Bild.7a41d7fd.svg";